import { render, staticRenderFns } from "./FormAnswers.vue?vue&type=template&id=7bfd1932"
import script from "./FormAnswers.js?vue&type=script&lang=js&external"
export * from "./FormAnswers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports